const EmergencyMaterial = (props: { fill: string }) => (
	<path
		transform="scale(0.0333) translate(0, 960)"
		d="M410-120v-238L204-239l-70-121 206-120-206-119 70-121 206 119v-239h140v239l206-119 70 121-206 119 206 120-70 121-206-119v238H410Z"
		fill={props.fill}
	/>
);

export default EmergencyMaterial;
